import styled from "styled-components";
import {
    ICountryData,
    IHandleBlur,
    IHandleChange,
    IHandleSubmit,
    ISetCustomerData,
} from "@interfaces";
import { DatePickerCommon, InputCommon, SelectCommon } from "@components";
import { breakpoint } from "@utilities";
import { useField, useFormikContext } from "formik";

interface IProps {
    values: ISetCustomerData;
    handleChange: IHandleChange;
    handleBlur: IHandleBlur;
    handleSubmit: IHandleSubmit;
    dateValue: Date | null | undefined;
    countriesData: ICountryData[];
    handleChangeDate: (date: Date | null, value?: string | null | undefined) => void;
    isLeader?: boolean;
    isShowErrorDate: boolean;
}

export const AddTravellerFormComponent = (props: IProps) => {
    const {
        values,
        handleChange,
        handleBlur,
        handleSubmit,
        dateValue,
        countriesData,
        handleChangeDate,
    } = props;

    const countriesModel = countriesData.map((item) => ({
        id: item.countryCode,
        label: item.name,
    }));
    const { setFieldValue } = useFormikContext();
    const [field] = useField(`countryCode`);
    const [dateOfBirthField, dateOfBirthMeta] = useField(`dateOfBirth`);

    return (
        <Container onSubmit={handleSubmit}>
            <div className="nameWrapper">
                <div className="firstName">
                    <InputCommon
                        name={`firstName`}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        value={values.firstName}
                        label="First name *"
                        type="text"
                        required
                    />
                </div>
                <div className="lastName">
                    <InputCommon
                        name={`lastName`}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        required
                        value={values.lastName}
                        label="Last name *"
                        type="text"
                    />
                </div>
            </div>
            <DatePickerCommon
                {...dateOfBirthField}
                {...dateOfBirthMeta}
                label="Date of birth *"
                value={dateValue}
                onChange={(date: Date | null) => handleChangeDate(date)}
                limitDate={{ maxDate: new Date(), minDate: new Date("1/1/1000") }}
                placeholder="DD/MM/YYYY"
            />
            <InputCommon
                className="phone"
                name={`phoneNumber`}
                handleChange={handleChange}
                handleBlur={handleBlur}
                value={values.phoneNumber}
                required
                label="Phone *"
                type="text"
            />
            <InputCommon
                name={`email`}
                handleChange={handleChange}
                handleBlur={handleBlur}
                value={values.email}
                label="Email *"
                required
                type="text"
            />
            <InputCommon
                name={`postalCode`}
                handleChange={handleChange}
                handleBlur={handleBlur}
                value={values.postalCode}
                label="Post code *"
                required
                type="text"
            />

            <SelectCommon
                name={`countryCode`}
                handleChange={(value) => setFieldValue(`countryCode`, value)}
                handleBlur={handleBlur}
                value={field.value}
                label="Country"
                required
                listValueMembers={countriesModel}
            />
        </Container>
    );
};

const Container = styled.form`
    .nameWrapper {
        display: flex;
        margin-bottom: 20px;
        width : 100%;
        justify-content: space-between;

        ${breakpoint.breakOnlyMobile`
            display : flex;
            flex-direction : column;
        `}
        .firstName {
            margin-right: 16px;
            width: 100%;
            ${breakpoint.breakOnlyMobile`
                margin-right: 0px;
            `}
        }
        .lastName {
            width: 100%;
        }
        
    }
`;
